import loadable from '@loadable/component'
import {getRouter} from 'hiya-common/src/routes'
import anchorcenter from './anchorcenter'
import chat from './chat'
import coinagency from './coinagency'
import crossRoomPk from './crossRoomPk'
import feedback from './feedback'
import game from './game'
import giftBook from './giftBook'
import guildSettled from './guildSettled'
import Helping from './Helping'
import hunting from './hunting'
import loginQuestion from './loginQuestion'
import union from './union'
import virtual from './virtual'
import wallet2 from './wallet2'
import cardMixture from './cardMixture'
import vip from './vip'
import medal from './medal'
import giftWall from './giftWall'
import lord from './lord'
import powernewuser from './powernewuser'
import TikTok from './TikTok'
import NewAnchorcenter from './NewAnchorcenter'
import LuckyGift from './LuckyGift'
import saada from './saada'
import discontinued from './discontinued'
import IntimateRelationship from './IntimateRelationship'

const routes = getRouter([
  ...IntimateRelationship,
  ...TikTok,
  ...lord,
  ...medal,
  ...giftWall,
  ...NewAnchorcenter,
  ...vip,
  ...LuckyGift,
  {
    path: '/PaidUserUnderTakingGroup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PaidUserUnderTakingGroup" */ '~/pages/PaidUserUnderTakingGroup'
        )
    ),
  },
  {
    path: '/FamilyContributeRank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FamilyContributeRank" */ '~/pages/FamilyContributeRank'
        )
    ),
  },
  {
    path: '/FirstCharge',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-FirstCharge" */ '~/pages/FirstCharge')
    ),
  },
  {
    path: '/BlindBoxGift',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BlindBoxGift" */ '~/pages/BlindBoxGift'
        )
    ),
  },
  {
    path: '/LuckyGift',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-LuckyGift" */ '~/pages/LuckyGift')
    ),
  },
  ...wallet2,
  ...virtual,
  {
    path: '/SongRoomTaskCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SongRoomTaskCenter" */ '~/pages/SongRoomTask/TaskCenter'
        )
    ),
  },
  {
    path: '/SnatchSingPlay',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SnatchSingPlay" */ '~/pages/SnatchSingPlay'
        )
    ),
  },
  {
    path: '/SongRoomSingerRankList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SongRoomSingerRankList" */ '~/pages/SongRoomTask/RankList'
        )
    ),
  },
  {
    path: '/UnionPK',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-UnionPK" */ '~/pages/UnionPK')
    ),
  },
  {
    path: '/FamilyPk',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-FamilyPk" */ '~/pages/FamilyPk')
    ),
  },
  {
    path: '/FamilyPkRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewBIgR-rule" */ '~/pages/FamilyPk/rule'
        )
    ),
  },
  {
    path: '/newbigr',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-NewBIgR" */ '~/pages/NewBIgR')
    ),
  },
  ...game,
  {
    path: '/GeneralLottery',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GeneralLottery" */ '~/pages/GeneralLottery'
        )
    ),
  },
  {
    path: '/bigr',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-BigR" */ '~/pages/BigR')
    ),
  },
  {
    path: '/Share',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Share" */ '~/pages/Share')
    ),
  },
  {
    path: '/unionTask',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-UnionTask" */ '~/pages/UnionTask')
    ),
  },
  {
    path: '/unionTask3',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-UnionTask3" */ '~/pages/UnionTask3')
    ),
  },
  {
    path: '/unionTask3/rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionTask3-rank" */ '~/pages/UnionTask3/Rank'
        )
    ),
  },
  {
    path: '/doubleroomtask',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DoubleRoomTask" */ '~/pages/DoubleRoomTask'
        )
    ),
  },
  {
    path: '/doubleroomtask/recruit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DoubleRoomTaskRecruit" */ '~/pages/DoubleRoomTask/recruit'
        )
    ),
  },
  {
    path: '/doubleroomtask/board',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DoubleRoomTask-board" */ '~/pages/DoubleRoomTask/board'
        )
    ),
  },
  {
    path: '/send',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Send" */ '~/pages/Send')
    ),
  },
  {
    path: '/UserInfoCollection',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UserInfoCollection" */ '~/pages/UserInfoCollection'
        )
    ),
  },
  {
    path: '/AnchorTaskSystem',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorTaskSystem" */ '~/pages/AnchorTaskSystem'
        )
    ),
  },
  {
    // 首页排行榜
    path: '/CoreRanking',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-CoreRanking" */ '~/pages/CoreRanking')
    ),
  },
  {
    // 首页排行榜
    path: '/HeatPointRank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HeatPointRank" */ '~/pages/HeatPointRank'
        )
    ),
  },
  {
    // 首页排行榜
    path: '/HeatPointRank/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HeatPointRankDetail" */ '~/pages/HeatPointRank/detail'
        )
    ),
  },
  {
    // 贵族/体验贵族 领取页
    path: '/NormalVipActive',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NormalVipActive" */ '~/pages/NormalVipActive'
        )
    ),
  },
  {
    // 自动跳转udesk
    path: '/Udesk',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-GoUdesk" */ '~/pages/GoUdesk')
    ),
  },
  // otherInfo携带邀请公会id m_union_id
  {
    path: '/Talent/invitation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentApply-invitation" */ '~/pages/TalentApply/invitation'
        )
    ),
  },
  {
    path: '/TalentApply',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-TalentApply" */ '~/pages/TalentApply')
    ),
  },
  {
    // 印尼新公会任务
    path: '/IdUnionTask',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-IdUnionTask" */ '~/pages/IdUnionTask')
    ),
  },
  {
    // 私信页面活动分享页面
    path: '/activity-sharing',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-activity-sharing" */ '~/pages/ActivitySharing'
        )
    ),
  },
  ...chat,
  ...feedback,
  ...hunting,
  ...coinagency,
  ...crossRoomPk,
  ...union,
  ...Helping,
  ...anchorcenter,
  ...loginQuestion,
  ...guildSettled,
  ...giftBook,
  ...cardMixture,
  ...powernewuser,
  ...saada,
  ...discontinued, // 此内路由本身已经删除，但是因为历史消息等原因仍会造成用户访问造成404，故此路由进行兜底
])

export default (store) => routes
// export default (store) => getRouter([...feedback])
